const timerRef = document.querySelector('.timer')

let count = 60

const id = setInterval(() => {
    if(count <= 1){
        clearInterval(id)
    }
    if(count === 30){
        alert('Половина часу')
    }
    count--

    let m = Math.floor(count / 60)
    let s = Math.floor(count % 60)
    timerRef.textContent = `хвилини: ${m < 10? '0' + m: m} секунди: ${s < 10? '0' + s: s}`
},1000)

const boxRef = document.querySelector('.box')
const secondRef = document.querySelector('.second')
const btnRef = document.querySelector('.btn')
let num = 30000
btnRef.addEventListener('click',() => {
btnRef.style.backgroundColor = 'red'
const idMs = setInterval(() => {
    if(Math.floor(num / 1000) <= 0 && Math.floor((num % 1000) / 10) <= 1){
        clearInterval(idMs)
        btnRef.style.backgroundColor = 'green'


    }
    if(Math.floor(num / 1000) === 10 ){
        boxRef.style.backgroundColor = 'green'
    }
    num -= 10
    let s = Math.floor(num / 1000)
    let ms = Math.floor((num % 1000) / 10)




    secondRef.textContent = `секунд: ${s} мілісекунд: ${ms} `
},10)

})

